import { takeEvery, put, call, CallEffect, PutEffect } from "redux-saga/effects";

import {
  DELETE_CREDENTIAL_LIST_ITEM,
  GET_CREDENTIAL_LIST,
  UPLOAD_CREDENTIAL,
} from "./actionTypes";

import {
  getCredentialListOk,
  getCredentialListErr,
  deleteCredentialListItemOk,
  deleteCredentialListItemErr,
  uploadCredentialOk,
  uploadCredentialErr,
} from "./actions";

import {
  getCredentials,
  deleteCredential,
  uploadCredential as uploadCredentialApi,
} from "~/helpers/backendHelper";

/********** LIST **********/

function* onGetCredentials({ payload: { id } }: any): Generator<CallEffect | PutEffect<any>, void, any> {
  try {
    const response: any = yield call(getCredentials, id);
    yield put(getCredentialListOk(response));
  } catch (error) {
    yield put(getCredentialListErr(error as Error));
  }
}

function* onDeleteCredentialListItem({ payload: { id } }: any): Generator<CallEffect | PutEffect<any>, void, any> {
  try {
    const response: any = yield call(deleteCredential, id);
    yield put(deleteCredentialListItemOk(id, response));
  } catch (error) {
    yield put(deleteCredentialListItemErr(id, error as Error));
  }
}

/********** FORM **********/

function* onUploadCredential({ payload: { data } }: any): Generator<CallEffect | PutEffect<any>, void, any> {
  try {
    const response: any = yield call(uploadCredentialApi, data);
    yield put(uploadCredentialOk(response));
  } catch (error) {
    yield put(uploadCredentialErr(error as Error));
  }
}

function* credentialSaga() {
  yield takeEvery(GET_CREDENTIAL_LIST, onGetCredentials);
  yield takeEvery(DELETE_CREDENTIAL_LIST_ITEM, onDeleteCredentialListItem);
  yield takeEvery(UPLOAD_CREDENTIAL, onUploadCredential);
}

export default credentialSaga;